import React, {useState, useEffect,useRef} from "react"
import {AiOutlineClose} from "react-icons/ai"
import "./PopUp.css"
import {Config} from "../../Config/config"
import popupss from "../../assets/popup.jpg"
export default function Popup() {
  const [isVisible, setIsVisible] = useState(true)
  const [popupData, setPopupData] = useState(null)
const contentRef = useRef(null);
  const closePopup = () => {
    setIsVisible(false)
  }

   const handleOverlayClick = (e) => {
    if (contentRef.current && !contentRef.current.contains(e.target)) {
      closePopup(); // dışa tıklandıysa kapat
    }
  };


  useEffect(() => {
    const fetchPopupData = async () => {
      try {
        const response = await fetch(`${Config.ApiBaseUrl}/modal/?firm=2`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${Config.Token}`,
          },
        })
        const data = await response.json()
        const randomIndex = Math.floor(Math.random() * data.length)
        setPopupData(data[randomIndex])
      } catch (error) {
        console.error("Error fetching popup data:", error)
      }
    }

    fetchPopupData()
  }, [])

  if (!isVisible || !popupData) {
    return null
  }

  return (
    <div className="popup-overlay"onClick={handleOverlayClick}>
      <div className="popup-content" ref={contentRef}>
        <AiOutlineClose className="close-icon" onClick={closePopup} />

        <a href={popupData.link} target="_blank" rel="noopener noreferrer">
          <img
            src={popupData.image || "default-image.jpg"}
            // src={popupss}
            className="image"
            alt="Popup Content"
          />
        </a>
      </div>
    </div>
  )
}
